import {
  UPDATE_COUNTRIES,
  UPDATE_CONDITION_OPERATOR,
  UPDATE_JOB_LEVELS,
  UPDATE_METRIC_NAMES,
  UPDATE_TENURE_OPERATORS,
} from './initialzeDataActionTypes';
import staticCountries from '../json/countries.json';
import staticJobLevels from '../json/jobLevels.json';
import staticConditionOperators from '../json/conditionOperators.json';
import staticMetricNames from '../json/metricNames.json';
import tenureConditionOptions from '../json/tenureConditionOperators.json';

export const updateCountriesResults = () => ({
  type: UPDATE_COUNTRIES,
  payload: staticCountries['countries'],
});

export const updateJobLevels = () => ({
  type: UPDATE_JOB_LEVELS,
  payload: staticJobLevels['jobLevels'],
});

export const updateConditionOperators = () => ({
  type: UPDATE_CONDITION_OPERATOR,
  payload: staticConditionOperators['conditionOperators'],
});

export const updateMetricNames = () => ({
  type: UPDATE_METRIC_NAMES,
  payload: staticMetricNames['metricNames'],
});

export const updateTenureOperators = () => ({
  type: UPDATE_TENURE_OPERATORS,
  payload: tenureConditionOptions['operators'],
});
